// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { OsiComponent } from './osi.component';
import { DatePipeModule } from 'libraries/date/date.module';

@NgModule({
    imports: [
        CommonModule,
        DatePipeModule,
    ],
    exports: [OsiComponent],
    declarations: [OsiComponent],
})
export class OsiModule { }
